<template>
  <div class="ylt-toast" :class="[toastClass, className]" v-show="visible">
    <i class="ylt-toast-icon" :class="icon"></i>{{ message }}
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      message: "", // 消息文字
      className: "", // 自定义类
      type: "info", // 类型 success info error warn
      duration: 2000, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器 
      visible: false // 是否显示
    };
  },
  computed: {
    toastClass() {
      let style = "";
      switch (this.type) {
        case "success":
          style = "toast-success";
          break;
        case "error":
          style = "toast-error";
          break;
        case "warning":
          style = "toast-warning";
          break;
        default:
          style = "toast-info";
          break;
      }
      return style;
    },
    icon() {
      let iconStyle = "";
      switch (this.type) {
        case "success":
          iconStyle = "el-icon-success";
          break;
        case "error":
          iconStyle = "el-icon-error";
          break;
        case "warning":
          iconStyle = "el-icon-warning";
          break;
        default:
          iconStyle = "el-icon-info";
          break;
      }
      return iconStyle;
    }
  },
  mounted() {
    this.startTimer();
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.destroyElement();
      }
    }
  },
  methods: {
    destroyElement() {
      this.$destroy();//销毁实例 
      this.$el.parentNode.removeChild(this.$el);
    },
    startTimer() {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true;
          clearTimeout(this.timer);
        }
      }, this.duration);
    }
  }
};
</script>

<style lang="scss" scoped>
.ylt-toast {
  position: fixed;
  z-index: 3000;
  left: 50%;
  top: 50%;
  display: flex;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  min-width: 200px;
  overflow: hidden;
  opacity: 1;
  transition: opacity 0.2s;
  transform: translate(-50%, -50%);
  .ylt-toast-icon {
    margin-right: 16px;
  }
}
.toast-info {
  background-color: #f4f4f5;
  color: #909399;
}
.toast-success {
  background-color: #f0f9eb;
  color: #67c23a;
}
.toast-warning {
  background-color: #fdf6ec;
  color: #e6a23c;
}
.toast-error {
  background-color: #fef0f0;
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue